import { openToast } from "store/slices/common/toast.slice";
import { getAllSettings, getAppSettings, updateSettings } from "store/services/settings";

import { createAsyncThunk } from "@reduxjs/toolkit";

export const GetAllSettingsAction = createAsyncThunk(
  "settings/getSettings",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await getAllSettings(payload);
      if (response.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(response);
      }
      return rejectWithValue({ message: response?.message });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const UpdateSettingsAction = createAsyncThunk(
  "settings/updateSettings",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...data } = payload;

    try {
      const response = await updateSettings(data);

      if (response.status === 1) {
        if (onSuccess) onSuccess(response);

        return fulfillWithValue(response);
      }

      dispatch(openToast({ type: "error", message: response?.message }));

      if (onError) onError(response);

      return rejectWithValue({ message: response?.message });
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";

      dispatch(openToast({ type: "error", message: errorMsg }));

      if (onError) onError(error);

      return rejectWithValue(error);
    }
  }
);

export const GetAppSettingsAction = createAsyncThunk(
  "settingsAll/getSettings",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await getAppSettings(payload);
      if (response.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(response);
      }
      return rejectWithValue({ message: response?.message });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
